<!--
 * @Author: kongxiangyu
 * @Date: 2022-11-19 16:33:02
 * @LastEditTime: 2023-02-08 19:09:31
 * @email: kongxiangyu@cd.baidu.com
 * @Description: 倒计时
-->
<template>
    <div id="countDown">
        <img
            src="../../../assets/text.png"
            alt=""
            class="title"
        >
        <div v-if="time" class="content">
            <span class="item">{{ time[0] }}{{ time[1] }}</span>
            <!-- <span class="item ml1">{{ time[1] }}</span> -->
            <span class="unit">天</span>
            <span class="item">{{ time[2] }}{{ time[3] }}</span>
            <!-- <span class="item ml1">{{ time[3] }}</span> -->
            <span class="unit">时</span>
            <span class="item">{{ time[4] }}{{ time[5] }}</span>
            <!-- <span class="item ml1">{{ time[5] }}</span> -->
            <span class="unit">分</span>
            <span class="item">{{ time[6] }}{{ time[7] }}</span>
            <!-- <span class="item ml1">{{ time[7] }}</span> -->
            <span class="unit">秒</span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        timestamp: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            startTime: this.timestamp,
            time: '',
            timer: null
        };
    },
    mounted() {
        this.startCount();
    },
    destroyed() {
        clearInterval(this.timer);
    },
    methods: {
        startCount() {
            this.time = this.getTime(this.startTime);
            this.timer = setInterval(() => {
                if (this.startTime > 0) {
                    this.startTime -= 1000;
                    this.time = this.getTime(this.startTime);
                    // console.log(this.time);
                }
                else {
                    clearInterval(this.timer);
                }
            }, 1000);
        },
        getTime(t) {
            // 如果后台给的是毫秒 上面不用除以1000  下面的计算时间也都要除以1000 这里我去掉1000了
            let d = Math.floor(t / 1000 / 60 / 60 / 24);// 天 var d=Math.floor(t/1000/60/60/24)
            let h = Math.floor(t / 1000 / 60 / 60 % 24);// 时 var h=Math.floor(t/1000/60/60%24)
            let m = Math.floor(t / 1000 / 60 % 60);// 分 var m=Math.floor(t/1000/60%60)
            let s = Math.floor(t / 1000 % 60);// 秒 var s=Math.floor(t/1000%60)
            if (parseInt(d, 10) < 10) {
                d = '0' + d;
            }
            if (parseInt(h, 10) < 10) {
                h = '0' + h;
            }
            if (parseInt(m, 10) < 10) {
                m = '0' + m;
            }
            if (parseInt(s, 10) < 10) {
                s = '0' + s;
            }
            return [d, h, m, s].join('');
        }
    }
};
</script>

<style lang="scss" scoped>
#countDown {
    width: calc(100% - 10px);
    height: 70px;
    margin:0 auto;
    // background-image: url('../../../assets/countdown.png');
    background-size: 100% 100%;
    position: relative;
    line-height: 20px;
    .title{
        width:100px;
        height:15px;
        display: block;
        position:absolute;
        font-size: 12px;
        font-weight: 600;
        font-family: Lantinghei SC;
        color:white;
        margin-left:10px;
        margin-top:19px;
    }
    .content{
        position:absolute;
        right:68px;
        top:16px;
        display: flex;
        .item{
            width: 22px;
            height: 20px;
            line-height:20px;
            color:#C7061E;
            background: white;
            border-radius: 2px;
            display: flex;
            justify-content: center;
            align-items: center;
            padding:0;
            margin:0;
        }
        .unit{
            color:#F9DCE4;
            font-size: 12px;
            font-family: Lantinghei SC;
            font-weight: 600;
        }
        .ml1{
            margin-left: 1px;
        }
        .unit{
            margin:0 2px;
        }
    }
}
</style>